const expertiseBlocks = [
  {
    tag: '研發能力',
    title: '自主研發，配方創新',
    desc: '康永生技擁有具備食品科學、營養學、生物化學背景的專業研發團隊，並持續追蹤國際原料趨勢，為客戶打造具差異化的獨特配方。',
    points: [
      '多位食品科學與生技專業研發人員',
      '自有分析檢測設備，確保配方穩定性',
      '定期參與國際原料展，掌握市場先機',
      '可配合客戶提供 NDA 保密協議',
    ],
    img: 'https://readdy.ai/api/search-image?query=Asian%20female%20scientist%20in%20white%20lab%20coat%20carefully%20pipetting%20herbal%20extract%20liquid%20into%20test%20tubes%20in%20a%20bright%20modern%20biotechnology%20research%20laboratory%2C%20rows%20of%20green%20plant%20samples%20on%20workbench%2C%20warm%20natural%20daylight%20streaming%20through%20window%2C%20shallow%20depth%20of%20field&width=720&height=500&seq=expertise-rd-02&orientation=landscape',
    imgLeft: false,
  },
  {
    tag: '生產製造',
    title: '專業生產廠房，嚴格管控制程',
    desc: '康永生技廠房通過國際 HACCP / ISO22000 認證，從原料入廠到成品出貨，每個環節均有完整的品管流程，確保每批次產品的安全與一致性。',
    points: [
      '符合國際認證規範的無塵生產環境',
      '全程溫溼度監控，確保原料品質',
      '多種劑型生產線，膠囊、錠劑、粉包、飲品',
      '每批次出具完整產品檢驗報告',
    ],
    img: 'https://readdy.ai/api/search-image?query=modern%20GMP%20certified%20pharmaceutical%20manufacturing%20facility%20production%20line%20with%20stainless%20steel%20equipment%20workers%20in%20white%20uniforms%20hairnets%2C%20clean%20room%20environment%2C%20health%20supplement%20factory%20interior&width=720&height=500&seq=expertise-mfg-01&orientation=landscape',
    imgLeft: true,
  },
  {
    tag: '品質管理',
    title: '全程品管，確保安全上市',
    desc: '我們建立完整的品質管理體系，從原料驗收、製程管控到成品檢驗，每個步驟均有標準作業程序，確保產品符合台灣及出口市場的法規要求。',
    points: [
      '原料供應商審核與定期稽查制度',
      '成品微生物、重金屬等安全指標檢驗',
      '協助客戶申請健康食品認證及標示審查',
      '完整的批次追蹤系統，支援產品回溯',
    ],
    img: 'https://readdy.ai/api/search-image?query=quality%20control%20inspector%20testing%20health%20supplement%20products%20in%20laboratory%20holding%20clipboard%20checking%20bottles%20tablets%20capsules%2C%20professional%20QC%20process%20in%20biotech%20facility%2C%20clean%20bright%20environment&width=720&height=500&seq=expertise-qc-01&orientation=landscape',
    imgLeft: false,
  },
];

export default function ExpertiseSection() {
  return (
    <section className="py-20 bg-[#f7faf7]">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-16">
          <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-4 border border-green-200">
            專業背景
          </span>
          <h2 className="text-[#1a2e1a] font-bold mb-4">
            研發 × 製造 × 品管<br className="hidden sm:block" />三位一體的專業實力
          </h2>
        </div>

        <div className="space-y-16">
          {expertiseBlocks.map((block) => (
            <div
              key={block.title}
              className={`flex flex-col ${block.imgLeft ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-10 lg:gap-16 items-center`}
            >
              {/* Text */}
              <div className="w-full lg:w-1/2">
                <span className="inline-block bg-green-100 text-[#4CAF50] text-[0.8125rem] font-medium px-3 py-1 rounded-full mb-4">
                  {block.tag}
                </span>
                <h3 className="text-[#1a2e1a] font-bold text-[1.625rem] leading-tight mb-4">{block.title}</h3>
                <p className="text-gray-600 text-[1.0625rem] leading-[1.75] mb-6">{block.desc}</p>
                <ul className="space-y-3">
                  {block.points.map((pt) => (
                    <li key={pt} className="flex items-start gap-3">
                      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-checkbox-circle-fill text-[#4CAF50] text-lg" />
                      </div>
                      <span className="text-gray-600 text-[0.9375rem] leading-[1.75]">{pt}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Image */}
              <div className="w-full lg:w-1/2 flex-shrink-0">
                <div className="rounded-2xl overflow-hidden">
                  <img
                    src={block.img}
                    alt={block.title}
                    className="w-full h-[320px] lg:h-[380px] object-cover object-top rounded-2xl"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}